import React from 'react';
import './Indicator.less';

export const IndicatorTypes = {
	SUCCESS: 'SUCCESS'
}

export const Indicator = ({type}) => {
	return <div className={`indicator ${
		type === IndicatorTypes.SUCCESS ? 'indicator--success' : ''
	}`}></div>
}
